(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("LinePlayer", [], factory);
	else if(typeof exports === 'object')
		exports["LinePlayer"] = factory();
	else
		root["LinePlayer"] = factory();
})(self, () => {
return 